exports = module.exports = require("../../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, ".bot-spinner {\n  position: relative;\n}\n", ""]);

// exports



//////////////////
// WEBPACK FOOTER
// ./node_modules/css-loader!./node_modules/vue-loader/lib/loaders/stylePostLoader.js!./node_modules/stylus-loader!./node_modules/vue-loader/lib??vue-loader-options!./src/components/bot/spinner/bot.spinner.vue?vue&type=style&index=0&id=b0a42c58&lang=stylus&
// module id = 715
// module chunks = 0 1 2 3 4 5 6 7 8 11